import { Button, Card, MessageBar, MessageBarBody, MessageBarTitle, Title2 } from '@fluentui/react-components';
import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../../config/routes';
import { useAuth } from '../../../hooks/useAuth';

export const LoginPage = () => {
  const { login, isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (isAuthenticated) return <Navigate to={ROUTES.DASHBOARD} replace />;

  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <Card>
        <Title2>CRM Partner Center</Title2>
        <p>Sign in to manage clients, orders, offers and commercial settings.</p>
        {error ? (
          <MessageBar intent="error"><MessageBarBody><MessageBarTitle>Authentication failed</MessageBarTitle>{error}</MessageBarBody></MessageBar>
        ) : null}
        <Button appearance="primary" disabled={loading} onClick={async () => { setLoading(true); setError(null); try { await login(); } catch (err) { setError(err instanceof Error ? err.message : 'Login failed.'); } finally { setLoading(false); } }}>
          {loading ? 'Signing in...' : 'Sign in'}
        </Button>
      </Card>
    </div>
  );
};
